const toHex = (num) => {
  return '0x' + num.toString(16)
}
const chainInfoMap = {
  1: {
    chainId: toHex(1),
    chainName: 'ETH Mainnet',
    nativeCurrency: {
      name: 'Ethereum',
      symbol: 'ETH',
      decimals: 18,
    },
    rpcUrls: ['https://mainnet.infura.io/v3/0b4a1511b8754bba96dcba520ea63e51'],
    blockExplorerUrls: ['https://etherscan.io']
  },
  3: {
    chainId: toHex(3),
    chainName: 'Ropsten',
    nativeCurrency: {
      name: 'Ethereum',
      symbol: 'ETH',
      decimals: 18,
    },
    rpcUrls: ['https://ropsten.infura.io/v3/0b4a1511b8754bba96dcba520ea63e51'],
    blockExplorerUrls: ['https://ropsten.etherscan.io']
  },
  4: {
    chainId: toHex(4),
    chainName: 'Rinkeby',
    nativeCurrency: {
      name: 'Ethereum',
      symbol: 'ETH',
      decimals: 18,
    },
    rpcUrls: ['https://rinkeby.infura.io/v3/0b4a1511b8754bba96dcba520ea63e51'],
    blockExplorerUrls: ['https://rinkeby.etherscan.io']
  },
  42: {
    chainId: toHex(42),
    chainName: 'Kovan',
    nativeCurrency: {
      name: 'Ethereum',
      symbol: 'ETH',
      decimals: 18,
    },
    rpcUrls: ['https://kovan.infura.io/v3/0b4a1511b8754bba96dcba520ea63e51'],
    blockExplorerUrls: ['https://kovan.etherscan.io']
  },
  56: {
    chainId: toHex(56),
    chainName: 'BSC',
    nativeCurrency: {
      name: 'BNB',
      symbol: 'BNB',
      decimals: 18,
    },
    rpcUrls: ['https://bsc-dataseed1.binance.org/'],
    blockExplorerUrls: ['https://bscscan.com']
  },
  128: {
    chainId: toHex(128),
    chainName: 'Heco',
    nativeCurrency: {
      name: 'HT',
      symbol: 'HT',
      decimals: 18,
    },
    rpcUrls: ['https://http-mainnet.hecochain.com/'],
    blockExplorerUrls: ['https://hecoinfo.com']
  },
  137: {
    chainId: toHex(137),
    chainName: 'Polygon(Matic)',
    nativeCurrency: {
      name: 'MATIC',
      symbol: 'MATIC',
      decimals: 18,
    },
    rpcUrls: ['https://rpc-mainnet.maticvigil.com/'],
    blockExplorerUrls: ['https://explorer.matic.network']
  },
  250: {
    chainId: toHex(250),
    chainName: 'Fantom Opera',
    nativeCurrency: {
      name: 'FTM',
      symbol: 'FTM',
      decimals: 18,
    },
    rpcUrls: ['https://rpc.ftm.tools/'],
    blockExplorerUrls: ['https://ftmscan.com/']
  },
  25: {
    chainId: toHex(25),
    chainName: 'Cronos',
    nativeCurrency: {
      name: 'CRO',
      symbol: 'CRO',
      decimals: 18,
    },
    rpcUrls: ['https://evm-cronos.crypto.org'],
    blockExplorerUrls: ['https://cronoscan.com/']
  },
  1313161554: {
    chainId: toHex(1313161554),
    chainName: 'Aurora',
    nativeCurrency: {
      name: 'aETH',
      symbol: 'aETH',
      decimals: 18,
    },
    rpcUrls: ['https://mainnet.aurora.dev'],
    blockExplorerUrls: ['https://aurorascan.dev/']
  },
  43114: {
    chainId: toHex(43114),
    chainName: 'Avalanche',
    nativeCurrency: {
      name: 'AVAX',
      symbol: 'AVAX',
      decimals: 18,
    },
    rpcUrls: ['https://api.avax.network/ext/bc/C/rpc'],
    blockExplorerUrls: ['https://snowtrace.io/']
  },
  1666600000: {
    chainId: toHex(1666600000),
    chainName: 'Harmony Shard 0',
    nativeCurrency: {
      name: 'ONE',
      symbol: 'ONE',
      decimals: 18,
    },
    rpcUrls: ['https://api.harmony.one'],
    blockExplorerUrls: ['https://explorer.harmony.one']
  },
  1284: {
    chainId: toHex(1284),
    chainName: 'Moonbeam',
    nativeCurrency: {
      name: 'GLMR',
      symbol: 'GLMR',
      decimals: 18,
    },
    rpcUrls: ['https://rpc.api.moonbeam.network'],
    blockExplorerUrls: ['https://moonbeam.moonscan.io/']
  },
  1285: {
    chainId: toHex(1285),
    chainName: 'Moonriver',
    nativeCurrency: {
      name: 'MOVR',
      symbol: 'MOVR',
      decimals: 18,
    },
    rpcUrls: ['https://rpc.moonriver.moonbeam.network'],
    blockExplorerUrls: ['https://moonriver.moonscan.io/']
  },
  42161: {
    chainId: toHex(42161),
    chainName: 'Arbitrum One',
    nativeCurrency: {
      name: 'AETH',
      symbol: 'AETH',
      decimals: 18,
    },
    rpcUrls: ['https://arb1.arbitrum.io/rpc'],
    blockExplorerUrls: ['https://arbiscan.io/']
  },
  10: {
    chainId: toHex(10),
    chainName: 'Optimistic Ethereum',
    nativeCurrency: {
      name: 'OETH',
      symbol: ')ETH',
      decimals: 18,
    },
    rpcUrls: ['https://mainnet.optimism.io/'],
    blockExplorerUrls: ['https://optimistic.etherscan.io/']
  }
}

const wrappedTokenList = [
  {
    address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
    name: "WETH"
  }
]

module.exports = {
  async waitForTx (self, error, transactionHash, callback) {
    console.log(error, transactionHash)
    let netId = await web3.eth.net.getId()
    let linkRender = h => h('a', {
        attrs: {
          target: '_blank',
          href: chainInfoMap[netId].blockExplorerUrls[0] + '/tx/' + transactionHash
        }
      },
      '在区块浏览器上查看 🔗'
    )

    if (error) {
      self.$Notice.error({
        title: '交易发送失败',
        desc: error.message
      })
      if (callback) callback(null, error)
    } else {

      self.$Notice.info({
        title: '正在等待交易上链...',
        duration: 0,
        name: transactionHash,
        render: h => {
          return h('span', [linkRender(h)])
        }
      })

      let handler = window.setInterval(() => {
        web3.eth.getTransactionReceipt(transactionHash, (error, receipt) => {
          console.log(error, receipt)
          if (!error && receipt) {
            self.$Notice.close(transactionHash)
            if (receipt.status) {
              self.$Notice.success({
                title: '交易成功',
                render: h => {
                  return h('span', [linkRender(h)])
                }
              })
            } else {
              self.$Notice.error({
                title: '交易失败',
                render: h => {
                  return h('span', [linkRender(h)])
                }
              })
            }
            window.clearInterval(handler)
            if (callback) callback(receipt, error)
          } else if(error) {
            if (callback) callback(receipt, error)
          }
        })
      }, 3000)

    }
  },
  chainInfoMap: chainInfoMap,
  wrappedTokenList: wrappedTokenList,
}
